"use strict";

angular.module("informaApp")
    .filter("kebab", function () {
        return function (string) {
            return _.kebabCase(string);
        }
    });